<template>
  <v-dialog v-model="computedDialogUiLogin" max-width="500px">
    <v-card class="elevation-12">
      <v-toolbar>
        <v-btn icon @click.native="methodDialogUi('login')">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Login</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-form>
          <v-text-field
            prepend-icon="person"
            name="login"
            label="Login"
            type="text"
          ></v-text-field>
          <v-text-field
            prepend-icon="lock"
            name="password"
            label="Password"
            id="password"
            type="password"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary">Login</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  computed: {
    computedDialogUiLogin() {
      return this.$store.state.ui.dialogs.login;
    }
  },
  methods: {
    methodDialogUi(dialog) {
      this.$store.commit("mutationDialogUi", {
        dialog: dialog
      });
    }
  }
};
</script>
